/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitGetEntityDataleaksAggQueries
 */
export interface MonitGetEntityDataleaksAggQueries {
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityDataleaksAggQueries
     */
    process_id?: string;
}

/**
 * Check if a given object implements the MonitGetEntityDataleaksAggQueries interface.
 */
export function instanceOfMonitGetEntityDataleaksAggQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitGetEntityDataleaksAggQueriesFromJSON(json: any): MonitGetEntityDataleaksAggQueries {
    return MonitGetEntityDataleaksAggQueriesFromJSONTyped(json, false);
}

export function MonitGetEntityDataleaksAggQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitGetEntityDataleaksAggQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'process_id': !exists(json, 'process_id') ? undefined : json['process_id'],
    };
}

export function MonitGetEntityDataleaksAggQueriesToJSON(value?: MonitGetEntityDataleaksAggQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'process_id': value.process_id,
    };
}

